import { Field, FormSpy } from 'react-final-form';

import { Input } from '@change-corgi/design-system-legacy/components/forms';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { RemainingCharacters } from 'src/app/shared/components/forms';
import { requiredValidatorWithNoMessage } from 'src/app/shared/form/validators';

import { MAX_TITLE_LENGTH } from '../../../../constants';
import type { PetitionUpdateFormValues, TitleInputProps } from '../../types';

import { useTitleInput } from './hooks/useTitleInput';

export function TitleInput({ initialValue }: TitleInputProps) {
	const {
		data: { totalCharactersRemaining },
		actions: { handleFormChange, trackFocus, translate },
	} = useTitleInput({ initialValue });

	return (
		<Box mt="xs" sx={{ width: '100%' }}>
			<Field<PetitionUpdateFormValues['title']>
				name="title"
				type="text"
				validate={requiredValidatorWithNoMessage}
				initialValue={initialValue}
			>
				{({ type, ...props }) => (
					<Input
						{...props.input}
						type="text"
						id="petition-update-title"
						onFocus={() => {
							trackFocus();
						}}
						data-testid={props.input.name}
						label={translate('fe.pages.petition_update_composer.update_headline')} // TODO: Replace with corgi string in CHANGE-57904
						placeholder="" // TODO
						maxLength={MAX_TITLE_LENGTH}
					/>
				)}
			</Field>
			<FormSpy subscription={{ values: true }} onChange={handleFormChange} />
			<RemainingCharacters count={totalCharactersRemaining} />
		</Box>
	);
}
